import { createContext, useContext } from 'react'

export type OptionChainStrikePositionMap = Record<
    number,
    {
        call?: { type: 'buy' | 'sell'; quantity: number }
        put?: { type: 'buy' | 'sell'; quantity: number }
    }
>

export const OptionChainPositionContext = createContext<OptionChainStrikePositionMap>({})

export const useOptionChainStrikePositionMap = () => useContext(OptionChainPositionContext)
